<template>
    <fade-inwards-animation
        :elements="[
            {
                element: () => $refs.section,
            },
            {
                element: () => $refs.left,
                direction: 'right',
            },
            {
                element: () => $refs.right,
                direction: 'left',
            },
        ]"
    >
        <div
            class="recipe-details-section"
            ref="section"
            id="recipe-details-section"
            v-test:recipeDetailsSection
        >
            <b-container>
                <b-row class="content-row">
                    <b-col
                        lg="5"
                        xl="4"
                        class="animate"
                        ref="left"
                    >
                        <div class="recipe-ingredients-container">
                            <recipe-ingredients
                                :ingredients="ingredients"
                            />
                        </div>
                    </b-col>
                    <b-col
                        lg="7"
                        xl="8"
                        class="animate"
                        ref="right"
                    >
                        <div class="recipe-instructions-container">
                            <recipe-instructions
                                :title="instructions.title"
                                :steps="instructions.steps"
                                :sub-title="instructions.subTitle"
                            />
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </fade-inwards-animation>
</template>

<script>
    import RecipeIngredients from '../../molecules/RecipeIngredients/RecipeIngredients';
    import RecipeInstructions from '../../molecules/RecipeInstructions/RecipeInstructions';

    export default {
        name: 'recipe-details-section',

        components: { RecipeInstructions, RecipeIngredients },

        props: {
            ingredients: {
                type: Array,
                default: () => ([]),
            },

            instructions: {
                type: Object,
                default: () => ({}),
            },
        },
    };
</script>

<style lang="scss" scoped>
    .recipe-ingredients-container {
        margin: 40px 15px 67px;

        @include media-breakpoint-up(lg) {
            margin-top: 44px;
            margin-bottom: 40px;
            padding-top: 30px;
            position: sticky;
            top: 0;
        }
    }

    .recipe-instructions-container:before {
        @include media-breakpoint-up(lg) {
            content: '';
            position: absolute;
            top: 0;
            bottom: 0;
            left: calc(100% - (#{$grid-gutter-width} / 2));
            width: calc((100vw - (960px - #{$grid-gutter-width})) / 2);
            background-color: secondary-palette(7);
        }
        @include media-breakpoint-up(xl) {
            left: calc(100% - (32px / 2));
            width: calc((100vw - (1344px - 32px)) / 2);
        }
    }

    .recipe-instructions {
        position: relative;
        z-index: 1;
    }
</style>
